export default "__VITE_ASSET__fe_L30wC__"